import {sanitizeInput} from "./PaystationFilteringLogic";

const filterByName = ( list, filterName ) => {
    if( ! filterName ) {
        return list;
    }
    const filtered = [];

    const cleanedFilter = sanitizeInput( filterName );

    if( list && list.length > 0 ) {
        list.forEach( account => {
            if( account.name?.toLowerCase().includes( cleanedFilter ) ||
                account.code?.toLowerCase().includes( cleanedFilter ) ||
                ( account.id?.toString().includes( cleanedFilter ) ) ) {
                filtered.push( account );
            }
        } );
    }
    return filtered;
}

const filterByType = (list, filterType) => {
    if( ! filterType || filterType === 0 ) {
        return list;
    }
    const filtered = [];
    if( list && list.length > 0 ) {
        list.forEach( account => {
            if( account.type === filterType ) {
                filtered.push( account );
            }
        } );
    }
    return filtered;
}

const nameMatchesFilter = ( candidate , filter ) => {
    return candidate?.userlabel?.toLowerCase().includes( filter.toLowerCase() );
};

const emailMatchesFilter = ( candidate , filter ) => {
    return candidate?.Email?.toLowerCase().includes( filter.toLowerCase() );
}

const phoneMatchesFilter = ( candidate , filter ) => {
    return candidate?.PhoneNumber?.includes( filter.toLowerCase() );
}

const groupMatchesFilter = ( candidate , filter ) => {
    return candidate?.accountlabel?.toLowerCase().includes( filter.toLowerCase() );
}

const userIdMatchesFilter = ( candidate , filter ) => {
    return candidate?.userid?.toString().includes( filter.toLowerCase() );
}

const filterUser = ( list , filter ) => {
    if( ! filter ) {
        return list;
    }
    const cleanedFilter = sanitizeInput( filter );
    const filtered = [];
    if( list && list.length > 0 ) {
        list.forEach( candidate => {
            if( nameMatchesFilter( candidate , cleanedFilter ) ||
                emailMatchesFilter( candidate , cleanedFilter ) ||
                phoneMatchesFilter( candidate , cleanedFilter ) ||
                groupMatchesFilter( candidate , cleanedFilter ) ||
                userIdMatchesFilter( candidate , cleanedFilter ) ) {
                filtered.push( candidate );
            }
        } );
    }
    return filtered;
};

/*const userBelongsToGroup = (userGroup, userName) => {
    const availableUsers = props.availableUsers;
    if( !availableUsers ) return false;

    const usersID = availableUsers
        .filter(user => user.userlabel.toLowerCase().includes(userName.toLowerCase()))
        .map(user => user.userid.toString());

    return userGroup.users.split(",")
        .map( userID => userID.trim() )
        .some( user => usersID.includes( user ) );
}*/ //What's the difference with userGroupUsersIncludes

const matchesGroupName = ( userGroup, name ) => {
    return userGroup.name?.toLowerCase().includes( name.toLowerCase() );
}

const matchesGroupId = ( userGroup, id ) => {
    return userGroup.id?.toString().includes( id );
}

const userBelongsToGroup = ( userGroup, userName ) => {
    const users = userGroup.users.split(",").map( userID => userID.trim() );
    return users.some( user => user.includes( userName ) );
}

const userBelongsToSubGroup = ( userGroup, groupName ) => {
    const groupsAttached = userGroup.groupsattached.split(",").map( userID => userID.trim() );
    return groupsAttached.some( group => group.includes( groupName ) );
}

const matchesCustomSelection = ( userGroup, selection ) => {
    return userGroup.selection?.toLowerCase().includes( selection );
}

const filterGroups = ( list , filter ) => {
    if( ! filter ) {
        return list;
    }

    const cleanedFilter = sanitizeInput( filter );
    const filtered = [];
    if( list && list.length > 0 ) {
        list.forEach( userGroup => {
            try {
                if ( matchesGroupName( userGroup, cleanedFilter ) ||
                     matchesGroupId( userGroup, cleanedFilter ) ||
                     userBelongsToGroup( userGroup, cleanedFilter ) ||
                     userBelongsToSubGroup( userGroup, cleanedFilter ) ||
                     matchesCustomSelection( userGroup, cleanedFilter ) ) {
                    filtered.push( userGroup );
                }
            } catch ( error ) {
                console.error( error );
            }
        } );
    }
    return filtered;
}

export { filterByType, filterByName , filterUser , filterGroups };
